import { merge, omit } from 'lodash';

import { ICustomer } from 'shared/domain/entities';

const removeMaskPlaceholder = (value?: string) => value?.replace(/_/g, '');

export default function buildCustomerUpdateBody(
  customer: Partial<ICustomer>,
  values: Partial<ICustomer>,
): Partial<ICustomer> {
  const hasGuardian = Boolean(customer.guardian || values.guardian);

  const body = merge(
    {},
    { address: customer.address, guardian: customer.guardian },
    values,
    {
      document: removeMaskPlaceholder(values.document),
      ...(hasGuardian
        ? {
            guardian: {
              document: removeMaskPlaceholder(values.guardian?.document),
            },
          }
        : {}),
    },
  );

  // O documento colapsado não sai daqui. O checkout manda RG e documento fiscal separados, cada
  // um para a sua coluna; o colapsado só existe para as telas que mostram um campo só. Se ele
  // viajasse junto — e ele viaja, porque o corpo recebe o cliente e o responsável inteiros — o
  // R.U.C. do paraguaio voltaria a ser gravado também como RG.
  return omit(body, [
    'alternativeDocument',
    'guardian.alternativeDocument',
  ]) as Partial<ICustomer>;
}
